import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { MarketingLayout } from './MarketingLayout';
import { CartDrawer } from './CartDrawer';
import { BottomNav } from './BottomNav';
import { InstallBanner } from '@molecules/InstallBanner';
import { QuantityModal } from '@molecules/QuantityModal';
import { ImageLightbox } from '@molecules/ImageLightbox';
import { OrderDetailModal } from '@molecules/OrderDetailModal';
import { OrderSuccessModal } from '@molecules/OrderSuccessModal';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

const PUBLIC_PATHS = new Set(['/', '/search', '/login', '/auth/sso/callback']);

export function Layout() {
  const online = useOnlineStatus();
  const { pathname } = useLocation();
  const isPublic = PUBLIC_PATHS.has(pathname);
  const isAdmin = pathname.startsWith('/admin') || pathname.startsWith('/dashboard/admin');
  const isWholesaler = pathname.startsWith('/wholesaler') || pathname.startsWith('/dashboard/wholesaler');

  const modals = (
    <>
      <CartDrawer />
      <QuantityModal />
      <ImageLightbox />
      <OrderDetailModal />
      <OrderSuccessModal />
    </>
  );

  if (isPublic) {
    return (
      <>
        <InstallBanner />
        {!online && (
          <div className="bg-amber-500 px-4 py-2 text-center text-sm font-medium text-white">
            Çevrimdışı mod — bazı özellikler kullanılamayabilir
          </div>
        )}
        <MarketingLayout>
          <Outlet />
        </MarketingLayout>
        {modals}
      </>
    );
  }

  if (isAdmin || isWholesaler) {
    return (
      <>
        <InstallBanner />
        {!online && (
          <div className="bg-amber-500 px-4 py-2 text-center text-sm font-medium text-white">
            Çevrimdışı mod — bazı özellikler kullanılamayabilir
          </div>
        )}
        <Outlet />
        {modals}
      </>
    );
  }

  return (
    <div className="flex min-h-screen flex-col bg-gray-50 text-gray-900">
      <InstallBanner />
      {!online && (
        <div className="bg-amber-500 px-4 py-2 text-center text-sm font-medium text-white">
          Çevrimdışı mod — bazı özellikler kullanılamayabilir
        </div>
      )}
      <Header mode="app" />
      <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-6 pb-24 md:pb-6">
        <Outlet />
      </main>
      <div className="hidden md:block">
        <Footer />
      </div>
      <BottomNav mode="app" />
      {modals}
    </div>
  );
}
